
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/storage-scholars-services",
      function () {
        return require("private-next-pages/storage-scholars-services/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/storage-scholars-services"])
      });
    }
  